import { render } from "./guide-authorinfo.vue?vue&type=template&id=ac437c38"
import script from "./guide-authorinfo.js?vue&type=script&lang=js"
export * from "./guide-authorinfo.js?vue&type=script&lang=js"

import "./guide-authorinfo.vue?vue&type=style&index=0&id=ac437c38&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__